/* Estado da aplicação em um lugar só. Quem precisa, importa daqui. */
export const S = {
  casos:   [],      // casos carregados do banco
  usuario: null,    // sessão do Supabase
  perfil:  null,    // linha da tabela perfis
  equipe:  [],      // outros perfis (só o admin enxerga)
  souAdmin:false,
  view:    "quadro",
  iniciado:false,
  // filtros da barra superior
  buscaCaso:"", buscaEsp:"", filtroEsp:"todos", filtroPend:false, filtroCap:""
};

/* Só os casos que passam pelos filtros ativos. */
export function visiveis(MAPA){
  const q=S.buscaCaso.trim().toLowerCase();
  return S.casos.filter(c=>{
    if(S.filtroPend && c.doc==="sim") return false;
    if(S.filtroCap && (c.captador||"")!==S.filtroCap) return false;
    if(!q) return true;
    const nome=c.codigo?(c.codigo+" "+(MAPA[c.codigo]?.nome||"")):"";
    return (c.cliente+" "+nome+" "+(c.captador||"")+" "+(c.obs||"")).toLowerCase().includes(q);
  });
}
export const captadores=()=>[...new Set(S.casos.map(c=>(c.captador||"").trim()).filter(Boolean))]
  .sort((a,b)=>a.localeCompare(b,"pt-BR"));
